import styles from './OrderedListControls.module.css';

/**
 * Compact up/down controls for manually ordered lists.
 */
export default function OrderedListControls({
    onMoveUp,
    onMoveDown,
    canMoveUp = true,
    canMoveDown = true,
    disabled = false,
}) {
    return (
        <span className={styles.controls}>
            <button
                type="button"
                className={styles.arrowBtn}
                onClick={onMoveUp}
                disabled={disabled || !canMoveUp}
                title="Move up"
                aria-label="Move up"
            >
                ↑
            </button>
            <button
                type="button"
                className={styles.arrowBtn}
                onClick={onMoveDown}
                disabled={disabled || !canMoveDown}
                title="Move down"
                aria-label="Move down"
            >
                ↓
            </button>
        </span>
    );
}

/**
 * One-shot “Alphabetize by name” action for a list header.
 */
export function AlphabetizeButton({
    onClick,
    disabled = false,
    label = 'Alphabetize by name',
}) {
    return (
        <button
            type="button"
            className={styles.alphabetizeBtn}
            onClick={onClick}
            disabled={disabled}
            title={label}
        >
            {label}
        </button>
    );
}
